export default __webpack_public_path__ + "static/media/insurance.276b9ffe.png";